var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBanknotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "heroicons-outline/banknotes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M2.25 19.25C7.71719 19.25 13.0136 19.9812 18.0468 21.3512C18.7738 21.5491 19.5 21.0086 19.5 20.2551V19.25M3.75 5V5.75C3.75 6.16421 3.41421 6.5 3 6.5H2.25M2.25 6.5V6.125C2.25 5.50368 2.75368 5 3.375 5H20.25M2.25 6.5V15.5M20.25 5V5.75C20.25 6.16421 20.5858 6.5 21 6.5H21.75M20.25 5H20.625C21.2463 5 21.75 5.50368 21.75 6.125V15.875C21.75 16.4963 21.2463 17 20.625 17H20.25M21.75 15.5H21C20.5858 15.5 20.25 15.8358 20.25 16.25V17M20.25 17H3.75M3.75 17H3.375C2.75368 17 2.25 16.4963 2.25 15.875V15.5M3.75 17V16.25C3.75 15.8358 3.41421 15.5 3 15.5H2.25M15 11C15 12.6569 13.6569 14 12 14C10.3431 14 9 12.6569 9 11C9 9.34315 10.3431 8 12 8C13.6569 8 15 9.34315 15 11ZM18 11H18.0075V11.0075H18V11ZM6 11H6.0075V11.0075H6V11Z",
    stroke: "black",
    strokeOpacity: 0.7,
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBanknotes);
export default __webpack_public_path__ + "static/media/banknotes.68b9b25e796c0a9c6f3628f65e650229.svg";
export { ForwardRef as ReactComponent };